import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'antd';
import styles from './NoTariffWarning.module.scss';
import useMeterTypes from '../../../../../queries/useMeterTypes';

const getUnavailableMeterTypes = (meterTypes) =>
  meterTypes
    .map((type) => type.name.trim())
    .toString()
    .split(',')
    .join(', ');

const NoTariffWarning = ({
  facilityAddress,
  facilityId,
  onClick,
  availableMeterTypes,
}) => {
  const { data: meterTypes } = useMeterTypes();
  const [unavailableMeterTypes, setUnavailableMeterTypes] = useState([]);

  const noAvailableTypesContent = useMemo(
    () =>
      `У объекта по адресу ${facilityAddress} не установлено ни одного тарифа. Без тарифов невозможно создать счетчик.`,
    [facilityAddress]
  );

  const content = useMemo(
    () =>
      `У объекта по адресу ${facilityAddress} не установлены следующие тарифы: ${getUnavailableMeterTypes(
        unavailableMeterTypes
      )}. Это значит, вы не сможете создать соответствующие типы счетчиков.`,
    [facilityAddress, unavailableMeterTypes]
  );

  useEffect(() => {
    if (meterTypes && availableMeterTypes.length) {
      const unAvailableMeterTypes = meterTypes.filter((meterType) => !availableMeterTypes.find((type) => type.name === meterType.name))
      setUnavailableMeterTypes(unAvailableMeterTypes);
    } else {
      setUnavailableMeterTypes([]);
    }
  }, [meterTypes, availableMeterTypes]);

  return (
    <div className={styles.container}>
      <Icon
        className={styles.warningIcon}
        type="warning"
        theme="twoTone"
        twoToneColor="#E41C1C"
      />
      <p className={styles.content}>
        {!availableMeterTypes.length ? noAvailableTypesContent : content}{' '}
        Заполните тарифы на вкладке «Тарифы» в «Объекте».{' '}
        <Link
          to={`/Offices/facilities/${facilityId}/tariffs`}
          className={styles.link}
          onClick={onClick}
        >
          Перейти к установке Тарифа
        </Link>
      </p>
    </div>
  );
};

export default NoTariffWarning;
